import * as React from "react"
import {cn} from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex items-center w-full px-[2.25rem] py-[1.875rem] rounded-[.75rem] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-black/50 placeholder:text-opacity-60 disabled:cursor-not-allowed disabled:opacity-50",
          "text-black/80 transition-all focus:outline outline-1 outline-offset-[5px] border border-black border-opacity-10 bg-white",
          "shadow-[inset_0_0_0_0px_rgba(113,169,97,0)] focus:shadow-[inset_0_0_0_3px_rgba(113,169,97,0.2)]",
          className
        )}
        style={{ outlineColor: "rgba(255, 255, 255, 0.07)" }}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
